import { loadScript } from '@/scripts/helpers/scriptLoader.helper';

let msalApp = null;
let currentRedirectUri = null;

const MSAL_SCRIPT_URL = 'https://alcdn.msauth.net/browser/2.37.0/js/msal-browser.min.js';

const msalConfig = (clientId, tenantId, redirectionUri) => ({
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: redirectionUri,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
});

const createMsalInstance = async (clientId, tenantId, redirectionUri) => {
  // Recria a instancia se o redirectUri mudar. Antes, o singleton (`if (!msalApp)`)
  // reaproveitava a primeira instancia e IGNORAVA o redirectUri das chamadas
  // seguintes — se a primeira fosse criada com "/" (MsalAuth), o login saia com
  // redirect_uri errado (raiz) e o Azure rejeitava (AADSTS50011).
  if (!msalApp || currentRedirectUri !== redirectionUri) {
    await loadScript(MSAL_SCRIPT_URL);
    msalApp = new window.msal.PublicClientApplication(
      msalConfig(clientId, tenantId, redirectionUri)
    );
    currentRedirectUri = redirectionUri;
  }
  return msalApp;
};

const getMsalInstance = () => msalApp;

export { createMsalInstance, getMsalInstance };